import Image from 'next/image';
import React from 'react';

import ScrollingMarqueeList from './common';

type StaticLogo = {
  src: string;
  alt: string;
};

type Props = {
  logos: StaticLogo[];
  logoHeight?: number;
};

const StaticScrollingLogosWidget: React.FC<Props> = React.memo(({ logos, logoHeight = 72 }) => {
  const renderItem = (item: StaticLogo) => (
    <span className="flex items-center align-middle select-none px-4">
      <div style={{ width: 150, height: logoHeight, position: 'relative' }}>
        <Image src={item.src} fill alt={item.alt} style={{ objectFit: 'contain' }} />
      </div>
    </span>
  );
  return (
    <div className="mt-6">
      <p className="text-center text-darkGray">Trusted by</p>
      <div className="flex flex-col text-center">
        <ScrollingMarqueeList items={logos} renderItem={renderItem} />
      </div>
    </div>
  );
});

StaticScrollingLogosWidget.displayName = 'StaticScrollingLogosWidget';
export default StaticScrollingLogosWidget;
